import {verifiedFetch} from '@github-ui/verified-fetch'
import type {MarkdownSubject} from './types'
import {useCallback} from 'react'

interface MarkdownPreviewRequest {
  text: string
  issue: string
  repository: string
  subjectType?: 'Issue' | 'PullRequest'
}

async function tryGetPreview({text, issue, repository, subjectType}: MarkdownPreviewRequest) {
  const formData = new FormData()
  formData.append('text', text)
  formData.append('issue', issue)
  formData.append('repository', repository)
  if (subjectType) {
    formData.append('subject_type', subjectType)
  }
  const response = await verifiedFetch('/preview', {body: formData, method: 'POST'})
  if (!response.ok) {
    // eslint-disable-next-line i18n-text/no-en
    return Promise.resolve('Markdown preview unavailable')
  }
  const htmlText = await response.text()
  return Promise.resolve(htmlText)
}

export function useGetPreview({subjectId, subjectType, subjectRepoId}: Partial<MarkdownSubject>) {
  return useCallback(
    async (body: string) => {
      return tryGetPreview({
        text: body,
        issue: subjectId?.toString() ?? '',
        repository: subjectRepoId?.toString() ?? '',
        subjectType: subjectType === undefined ? undefined : subjectType === 'issue' ? 'Issue' : 'PullRequest',
      })
    },
    [subjectId, subjectType, subjectRepoId],
  )
}
